import { render } from "./CoinTable.vue?vue&type=template&id=2ca07ea1&scoped=true"
import script from "./CoinTable.vue?vue&type=script&lang=js"
export * from "./CoinTable.vue?vue&type=script&lang=js"

import "./CoinTable.vue?vue&type=style&index=0&id=2ca07ea1&scoped=true&lang=css"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca07ea1"]])

export default __exports__